// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___3d0us","open":"open___1GLGU","background":"background___IUCOu","text":"text___1se1c"};